export default __webpack_public_path__ + "alberta-iv-patient.973a428754458c3c9893.svg";